module.exports = __webpack_public_path__ + "static/media/checkatrade-com.d402a508.png";